import {Component} from 'react'
import {Link} from 'react-router-dom'
import {IoMdHome} from 'react-icons/io'
import {FaFire} from 'react-icons/fa'
import {SiYoutubegaming} from 'react-icons/si'
import {MdPlaylistAdd} from 'react-icons/md'

import AppContext from '../../context/AppContext'

import {
  SideBarContainer,
  RoutesContainer,
  RouteItemContainer,
  RouteName,
  Icons,
  ContactUsContainer,
  AppsIconsContainer,
  AppIcon,
  Heading,
  Para,
  LinkEl,
} from './styledComponents'

class SideBar extends Component {
  render() {
    return (
      <AppContext.Consumer>
        {value => {
          const {theme, isSideBarVisible} = value
          console.log(this.props)
          const {path} = this.props
          console.log(path === '/')
          return (
            <SideBarContainer theme={theme} isSideBarVisible={isSideBarVisible}>
              <RoutesContainer as="ul" theme={theme}>
                <LinkEl as={Link} to="/">
                  <RouteItemContainer
                    as="li"
                    select={path === '/'}
                    theme={theme}
                  >
                    <Icons
                      theme={theme}
                      as={IoMdHome}
                      select={path === '/'}
                      size={20}
                    />
                    <RouteName select={path === '/'} theme={theme}>
                      Home
                    </RouteName>
                  </RouteItemContainer>
                </LinkEl>
                <LinkEl as={Link} to="/trending">
                  <RouteItemContainer
                    as="li"
                    select={path === '/trending'}
                    theme={theme}
                  >
                    <Icons
                      theme={theme}
                      as={FaFire}
                      select={path === '/trending'}
                      size={20}
                    />
                    <RouteName select={path === '/trending'} theme={theme}>
                      Trending
                    </RouteName>
                  </RouteItemContainer>
                </LinkEl>
                <LinkEl as={Link} to="/gaming">
                  <RouteItemContainer
                    as="li"
                    select={path === '/gaming'}
                    theme={theme}
                  >
                    <Icons
                      theme={theme}
                      as={SiYoutubegaming}
                      select={path === '/gaming'}
                      size={20}
                    />
                    <RouteName select={path === '/gaming'} theme={theme}>
                      Gaming
                    </RouteName>
                  </RouteItemContainer>
                </LinkEl>
                <LinkEl as={Link} to="/saved-videos">
                  <RouteItemContainer
                    as="li"
                    select={path === '/saved-videos'}
                    theme={theme}
                  >
                    <Icons
                      theme={theme}
                      as={MdPlaylistAdd}
                      select={path === '/saved-videos'}
                      size={20}
                    />
                    <RouteName select={path === '/saved-videos'} theme={theme}>
                      Saved videos
                    </RouteName>
                  </RouteItemContainer>
                </LinkEl>
              </RoutesContainer>
              <ContactUsContainer>
                <Heading theme={theme}>CONTACT US</Heading>
                <AppsIconsContainer>
                  <AppIcon
                    src="https://assets.ccbp.in/frontend/react-js/nxt-watch-facebook-logo-img.png"
                    alt="facebook logo"
                  />
                  <AppIcon
                    src="https://assets.ccbp.in/frontend/react-js/nxt-watch-twitter-logo-img.png"
                    alt="twitter logo"
                  />
                  <AppIcon
                    src="https://assets.ccbp.in/frontend/react-js/nxt-watch-linked-in-logo-img.png"
                    alt="linked in logo"
                  />
                </AppsIconsContainer>
                <Para theme={theme}>
                  Enjoy! Now to see your channels and recommendations!
                </Para>
              </ContactUsContainer>
            </SideBarContainer>
          )
        }}
      </AppContext.Consumer>
    )
  }
}

export default SideBar
